var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "run-calculation" }, [
    _c(
      "div",
      { staticClass: "flex-container pl-2 pr-2" },
      [
        _vm.shouldShowModalComponent
          ? _c(
              "modal-box",
              {
                attrs: { open: _vm.shouldShowModalComponent, width: "auto" },
                domProps: {
                  onClose: _vm.closeModal,
                  enableHeader: true,
                  enableFooter: true,
                  enableHeaderClose: true,
                  transparentOverlay: false,
                  closeOnClickOutside: true,
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "header",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("div", { staticClass: "flex-row flex-1" }, [
                      _c("div", { staticClass: "flex-col flex-1" }, [
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("runCalculationForAssetsAndComponents")
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
                _c("span", [
                  _vm.shouldShowModalStatus
                    ? _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("status")) + " : " + _vm._s(_vm.status)
                        ),
                      ])
                    : _c("div", { staticClass: "flex-row flex-1" }, [
                        _c(
                          "div",
                          { staticClass: "flex-col flex-1" },
                          [
                            _c("label", { staticClass: "checkbox-container" }, [
                              _c(
                                "div",
                                { staticClass: "flex-row checkboxFilter mb-2" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.isCheckAllAssets,
                                        expression: "isCheckAllAssets",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.isCheckAllAssets
                                      )
                                        ? _vm._i(_vm.isCheckAllAssets, null) >
                                          -1
                                        : _vm.isCheckAllAssets,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.checkAllAssests()
                                      },
                                      change: function ($event) {
                                        var $$a = _vm.isCheckAllAssets,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.isCheckAllAssets =
                                                $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.isCheckAllAssets = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.isCheckAllAssets = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("forAllAssestAndComponents")
                                      ) +
                                      " "
                                  ),
                                  _c("span", { staticClass: "checkmark" }),
                                ]
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "flex-row checkboxFilter mb-2",
                                staticStyle: { "font-weight": "bolder" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("runCalculationFor")) +
                                    " " +
                                    _vm._s(_vm.asset.name) +
                                    " "
                                ),
                              ]
                            ),
                            _c("label", { staticClass: "checkbox-container" }, [
                              _c(
                                "div",
                                { staticClass: "flex-row checkboxFilter" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.isCheckAll,
                                        expression: "isCheckAll",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(_vm.isCheckAll)
                                        ? _vm._i(_vm.isCheckAll, null) > -1
                                        : _vm.isCheckAll,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.checkAll()
                                      },
                                      change: function ($event) {
                                        var $$a = _vm.isCheckAll,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.isCheckAll = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.isCheckAll = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.isCheckAll = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("selectAll")) + " "
                                  ),
                                  _c("span", { staticClass: "checkmark" }),
                                ]
                              ),
                            ]),
                            _vm._l(
                              _vm.componentList,
                              function (componentTitle, index) {
                                return _c(
                                  "label",
                                  {
                                    key: index,
                                    staticClass: "checkbox-container",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex-row flex-4 checkboxFilter",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.checkedComponents,
                                              expression: "checkedComponents",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            value: componentTitle.id,
                                            checked: Array.isArray(
                                              _vm.checkedComponents
                                            )
                                              ? _vm._i(
                                                  _vm.checkedComponents,
                                                  componentTitle.id
                                                ) > -1
                                              : _vm.checkedComponents,
                                          },
                                          on: {
                                            change: [
                                              function ($event) {
                                                var $$a = _vm.checkedComponents,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = componentTitle.id,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.checkedComponents =
                                                        $$a.concat([$$v]))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.checkedComponents =
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                  }
                                                } else {
                                                  _vm.checkedComponents = $$c
                                                }
                                              },
                                              function ($event) {
                                                return _vm.updateCheckall()
                                              },
                                            ],
                                          },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(componentTitle.component) +
                                            " "
                                        ),
                                        _c("span", {
                                          staticClass: "checkmark",
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]),
                ]),
                _c(
                  "span",
                  {
                    staticClass: "footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c("div", { staticClass: "flex-row reverse" }, [
                      !_vm.shouldShowModalStatus
                        ? _c(
                            "div",
                            { staticClass: "flex-col flex-align-end mt-1" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn run-calculation",
                                  attrs: { disabled: _vm.disableRun() },
                                  on: {
                                    click: function ($event) {
                                      return _vm.run()
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("run")) + " ")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }